import React from "react"
import { Script, ScriptStrategy } from "gatsby"

const US_DOMAIN = "www.urbanarmorgear.com"
const MX_DOMAIN = "www.urbanarmorgear.mx"
const PH_DOMAIN = "www.urbanarmorgear.ph"
const GE_DOMAIN = "de.urbanarmorgear.com"
const HK_DOMAIN = "hk.urbanarmorgear.com"
const TH_DOMAIN = "th.urbanarmorgear.com"

const frosmoBaseProps = {
  type: "text/javascript",
  charset: "utf-8",
  strategy: ScriptStrategy.postHydrate,
  async: true,
}

interface ScriptsProps {}

const Scripts: React.FC<ScriptsProps> = () => {
  const [frosmoReady, setFrosmoReady] = React.useState<boolean>(false)
  const [frosmoScriptProps, setFrosmoScriptProps] = React.useState<any>({
    ...frosmoBaseProps,
    src: "//d22j8luu453d90.cloudfront.net/frosmo.easy.js",
  })
  const [frosmoScriptLocalizedProps, setFrosmoScriptLocalizedProps] =
    React.useState<any>({
      ...frosmoBaseProps,
      src: "//d22j8luu453d90.cloudfront.net/sites/urbanarmorgear_com_u.js",
    })

  React.useEffect(() => {
    if (typeof window !== undefined) {
      const host = window.location.hostname

      if (host === MX_DOMAIN) {
        setFrosmoScriptProps({
          ...frosmoBaseProps,
          src: "//d22j8luu453d90.cloudfront.net/frosmo.easy.js",
        })
        setFrosmoScriptLocalizedProps({
          ...frosmoBaseProps,
          src: "//d22j8luu453d90.cloudfront.net/sites/urbanarmorgear_mx.js",
        })
      } else if (host === PH_DOMAIN) {
        setFrosmoScriptProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/frosmo.easy.js",
        })
        setFrosmoScriptLocalizedProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/sites/urbanarmorgear_ph.js",
        })
      } else if (host === GE_DOMAIN) {
        setFrosmoScriptProps({
          ...frosmoBaseProps,
          src: "//d2wzl9lnvjz3bh.cloudfront.net/frosmo.easy.js",
        })
        setFrosmoScriptLocalizedProps({
          ...frosmoBaseProps,
          src: "//d2wzl9lnvjz3bh.cloudfront.net/sites/de_urbanarmorgear_com.js",
        })
      } else if (host === HK_DOMAIN) {
        setFrosmoScriptProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/frosmo.easy.js",
        })
        setFrosmoScriptLocalizedProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/sites/hk_urbanarmorgear_com.js",
        })
      } else if (host === TH_DOMAIN) {
        setFrosmoScriptProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/frosmo.easy.js",
        })
        setFrosmoScriptLocalizedProps({
          ...frosmoBaseProps,
          src: "//dk0tzorg7uge9.cloudfront.net/sites/th_urbanarmorgear_com.js",
        })
      }
    }

    setFrosmoReady(true)
  }, [])

  return (
    <React.Fragment>
      {frosmoReady && (
        <Script key={frosmoScriptProps.src} {...frosmoScriptProps} />
      )}
      {frosmoReady && (
        <Script
          key={frosmoScriptLocalizedProps.src}
          {...frosmoScriptLocalizedProps}
        />
      )}
      <Script
        {...{
          src: "https://cdn-loyalty.yotpo.com/loader/8FD8BZNCjea0pem73-TWdA.js",
          strategy: ScriptStrategy.postHydrate,
        }}
      />
      <Script
        {...{
          src: "https://cdn-widgetsrepository.yotpo.com/v1/loader/8FD8BZNCjea0pem73-TWdA",
          strategy: ScriptStrategy.postHydrate,
        }}
      />
      <Script
        {...{
          src: "https://cdn.swellrewards.com/loader/8FD8BZNCjea0pem73-TWdA.js",
          strategy: ScriptStrategy.postHydrate,
        }}
      />
    </React.Fragment>
  )
}

export default Scripts
